export const validateNumber = (value: number | undefined | null, defaultValue: number) => {
  if (
    value === undefined ||
    value === null ||
    isNaN(value) ||
    value === Infinity ||
    value === -Infinity
  ) {
    return defaultValue;
  }
  return value;
};
